module.exports = __webpack_public_path__ + "static/media/trnava.199bce5c.jpg";